<template>
    <article
        :id="chapter.id"
        class="g11c-chapter"
        :class="{ 'g11c-chapter--alt': alternate }"
    >
        <div class="g11c-wrap g11c-chapter__grid">
            <div class="g11c-chapter__visual" aria-hidden="true">
                <div class="g11c-chapter__icon-card">
                    <span class="g11c-chapter__num">{{ String(chapter.number).padStart(2, '0') }}</span>
                    <lucide-icon :name="chapter.icon" :size="36" class="g11c-chapter__icon" />
                </div>
            </div>

            <div class="g11c-chapter__content">
                <p class="g11c-chapter__eyebrow">الفصل {{ chapter.number }}</p>
                <h3 class="g11c-chapter__title">{{ chapter.arabicTitle }}</h3>
                <p class="g11c-chapter__en ltr-inline">{{ chapter.englishTitle }}</p>

                <p v-if="chapter.openingQuestion" class="g11c-chapter__question">
                    {{ chapter.openingQuestion }}
                </p>

                <p
                    v-for="(paragraph, index) in chapter.paragraphs"
                    :key="`${chapter.id}-p-${index}`"
                    class="g11c-chapter__text"
                >
                    {{ paragraph }}
                </p>

                <div v-if="chapter.showDataFlow" class="g11c-data-flow" aria-label="مسار البيانات">
                    <span>Data</span>
                    <lucide-icon name="ArrowLeft" :size="16" />
                    <span>Information</span>
                    <lucide-icon name="ArrowLeft" :size="16" />
                    <span>Decisions</span>
                </div>

                <div class="g11c-concepts">
                    <p class="g11c-concepts__label">مفاهيم مهمة</p>
                    <ul class="g11c-concepts__list">
                        <li v-for="concept in chapter.concepts" :key="concept" class="ltr-inline">
                            {{ concept }}
                        </li>
                    </ul>
                </div>

                <aside class="g11c-core-idea">
                    <p class="g11c-core-idea__label">الفكرة الأساسية</p>
                    <p class="g11c-core-idea__text">{{ chapter.coreIdea }}</p>
                </aside>
            </div>
        </div>
    </article>
</template>

<script>
import LucideIcon from '@/components/welcome/landing/LucideIcon.vue';

export default {
    name: 'CurriculumChapter',
    components: { LucideIcon },
    props: {
        chapter: { type: Object, required: true },
        alternate: { type: Boolean, default: false },
    },
};
</script>
